const getSubdomain = (url: string): string | null => {
  // This regex matches a URL pattern:
  // ^ - Start of the string
  // (https?:\/\/) - Matches 'http://' or 'https://' (optional)
  // ([A-Za-z_0-9.-]+) - Captures one or more alphanumeric characters, underscores, dots, or hyphens (the subdomain)
  // (.*) - Matches any remaining characters in the URL
  // The captured group ([A-Za-z_0-9.-]+) will contain the subdomain
  const match = url.match(/^(?:https?:\/\/)?([A-Za-z_0-9.-]+).*/);
  if (match && match[1]) {
    return match[1].split('.')[0];
  }
  return null;
};

export const getCompanySlug = (url: string): string => {
  // If in development and the VITE_DEV_FALLBACK_URL is set, use it instead of the url which is (localhost:5173)
  const resolvedUrl =
    import.meta.env.VITE_NODE_ENV === 'dev' && import.meta.env.VITE_DEV_FALLBACK_URL
      ? import.meta.env.VITE_DEV_FALLBACK_URL
      : url;

  const subdomain = getSubdomain(resolvedUrl);
  const CUSTOMER_APP_ONLY_SUBDOMAIN = 'app';

  if (!subdomain || subdomain === CUSTOMER_APP_ONLY_SUBDOMAIN) {
    return '';
  }

  return subdomain;
};
